// Helpers for the lesson "number" field (global course order) and the
// per-type position shown next to it (e.g. Basics #3).

// Next free global number: one past the highest existing number.
export function nextLessonNumber(lessons) {
    const max = lessons.reduce((m, l) => {
        const n = Number(l.number);
        return Number.isFinite(n) && n > m ? n : m;
    }, 0);
    return max + 1;
}

// Map of lessonId -> 1-based position among non-archived lessons of the same
// type, ordered by global number.
export function typePositions(lessons) {
    const counts = {};
    const positions = {};
    lessons
        .filter((l) => !l.archived && l.type)
        .sort((a, b) => (Number(a.number) || 0) - (Number(b.number) || 0))
        .forEach((l) => {
            counts[l.type] = (counts[l.type] || 0) + 1;
            positions[l.id] = counts[l.type];
        });
    return positions;
}

// Position a lesson of `type` with global `number` would have among the other
// (non-archived) lessons of that type. `selfId` is excluded (for edits).
export function typePositionFor(lessons, type, number, selfId) {
    const n = Number(number);
    if (!type || !Number.isFinite(n)) return null;
    const before = lessons.filter(
        (l) => l.id !== selfId && !l.archived && l.type === type && (Number(l.number) || 0) < n
    ).length;
    return before + 1;
}

// Another lesson already using this number, if any.
export function lessonWithNumber(lessons, number, selfId) {
    const n = Number(number);
    if (!Number.isFinite(n) || number === "") return null;
    return lessons.find((l) => l.id !== selfId && Number(l.number) === n) || null;
}
